(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohmoto-hero"] && !Shopify.designMode) return;
  try {
    
  function initOhmotoMotion(root=document){
    root.querySelectorAll('[data-ohmoto-hero]').forEach(hero=>{
      if(hero.dataset.initialized)return;
      hero.dataset.initialized='true';
      const videos=[...hero.querySelectorAll('video')],button=hero.querySelector('button');
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      let enabled=!reduced.matches;
      const sync=()=>{button.textContent=enabled?button.dataset.pauseLabel:button.dataset.playLabel;button.setAttribute('aria-pressed',String(enabled));videos.forEach(v=>{v.muted=true;if(enabled)v.play().catch(()=>{});else v.pause()})};
      button.addEventListener('click',()=>{enabled=!enabled;sync()});
      reduced.addEventListener('change',e=>{enabled=!e.matches;sync()});
      sync();
    });
  }
  initOhmotoMotion();
  document.addEventListener('shopify:section:load',e=>initOhmotoMotion(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohmoto-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-ohmoto-videos] [data-video-id]');
    if(!button)return;
    const frame=document.createElement('iframe');
    frame.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(button.dataset.videoId)+'?autoplay=1&rel=0';
    frame.title=button.getAttribute('aria-label');
    frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen=true;
    button.replaceWith(frame);
    frame.focus();
  });
  document.addEventListener('error',event=>{
    if(event.target.matches?.('[data-ohmoto-videos] img'))event.target.hidden=true;
  },true);

  } catch(e) { console.error(e); }
})();
})();
